var render = function () {
  var _vm$issue, _vm$issue$member, _vm$issue2, _vm$issue2$member, _vm$issue3, _vm$issue3$member, _vm$issue4, _vm$issue5, _vm$issue6, _vm$issue7, _vm$issue8, _vm$issue9, _vm$previewFileItem, _vm$previewFileItem2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iha-detail-page page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('b-button', {
    staticClass: "back-button d-flex align-items-center gap-2",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m7.825 13l5.6 5.6L12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2z"
    }
  })])]), _vm._v(" Back to Issues ")])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 mb-3 mb-lg-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column gap-3"
  }, [_c('div', {
    staticClass: "iha-card-container d-flex flex-column gap-3"
  }, [_c('div', {
    staticClass: "user-info-container d-flex justify-content-between align-items-start gap-2 flex-wrap"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center gap-2 flex-wrap"
  }, [_c('h4', {
    staticClass: "user-name m-0"
  }, [_vm._v(" " + _vm._s((_vm$issue = _vm.issue) === null || _vm$issue === void 0 ? void 0 : (_vm$issue$member = _vm$issue.member) === null || _vm$issue$member === void 0 ? void 0 : _vm$issue$member.cfname) + " " + _vm._s(((_vm$issue2 = _vm.issue) === null || _vm$issue2 === void 0 ? void 0 : (_vm$issue2$member = _vm$issue2.member) === null || _vm$issue2$member === void 0 ? void 0 : _vm$issue2$member.cmname) || '') + " " + _vm._s((_vm$issue3 = _vm.issue) === null || _vm$issue3 === void 0 ? void 0 : (_vm$issue3$member = _vm$issue3.member) === null || _vm$issue3$member === void 0 ? void 0 : _vm$issue3$member.clname) + " ")]), _c('span', {
    staticClass: "status-badge-issue",
    class: _vm.issue.status
  }, [_vm._v(" " + _vm._s((_vm$issue4 = _vm.issue) === null || _vm$issue4 === void 0 ? void 0 : _vm$issue4.status) + " ")]), _c('span', {
    staticClass: "status-badge-issue issue-type",
    class: _vm.issue.type
  }, [_vm._v(_vm._s((_vm$issue5 = _vm.issue) === null || _vm$issue5 === void 0 ? void 0 : _vm$issue5.type))])]), _c('div', {
    staticClass: "user-email"
  }, [_vm._v(" " + _vm._s((_vm$issue6 = _vm.issue) === null || _vm$issue6 === void 0 ? void 0 : _vm$issue6.email) + " ")])]), _c('div', {
    staticClass: "right-content"
  }, [_vm.issue.status === 'pending' ? _c('button', {
    staticClass: "withdraw-btn-outline d-flex align-items-center gap-2",
    on: {
      "click": _vm.openWithdrawModal
    }
  }, [_vm._m(0), _vm._v(" Withdraw ")]) : _vm._e()])]), _c('div', {
    staticClass: "iha-issue-info d-flex gap-3 flex-wrap"
  }, [_c('div', {
    staticClass: "info-item d-flex gap-2"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }
  }), _c('path', {
    attrs: {
      "d": "M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 9h1m-1 4h6m-6 4h6"
    }
  })])])]), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Plan")]), _c('div', {
    staticClass: "info-text"
  }, [_vm._v(_vm._s(((_vm$issue7 = _vm.issue) === null || _vm$issue7 === void 0 ? void 0 : _vm$issue7.plan) || '-'))])])]), _c('div', {
    staticClass: "info-item d-flex gap-2"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1Z"
    }
  })])]), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Submitted On")]), _c('div', {
    staticClass: "info-text"
  }, [_vm._v(_vm._s(((_vm$issue8 = _vm.issue) === null || _vm$issue8 === void 0 ? void 0 : _vm$issue8.submittedOn) || '-'))])])])])]), _c('div', {
    staticClass: "iha-card-maincontainer"
  }, [_c('div', {
    staticClass: "heading-section d-flex align-items-center"
  }, [_c('div', {
    staticClass: "icon-wrapper d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }
  }), _c('path', {
    attrs: {
      "d": "M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 9h1m-1 4h6m-6 4h6"
    }
  })])])]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Description")])]), _c('div', {
    staticClass: "body-container d-flex flex-column"
  }, [_c('div', {
    staticClass: "desc-container"
  }, [_vm._v(" " + _vm._s(((_vm$issue9 = _vm.issue) === null || _vm$issue9 === void 0 ? void 0 : _vm$issue9.description) || '-') + " ")]), _vm.documents && _vm.documents.length > 0 ? _c('div', {
    staticClass: "attached_container"
  }, [_c('div', {
    staticClass: "attach_title"
  }, [_vm._v("Attached Files (" + _vm._s(_vm.documents.length) + ")")]), _c('div', {
    staticClass: "file_list d-flex gap-2 flex-wrap"
  }, _vm._l(_vm.documents, function (doc) {
    return _c('div', {
      key: doc.id,
      staticClass: "file_list-item",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": doc.original_file_name
      },
      on: {
        "click": function click($event) {
          return _vm.previewFile(doc);
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "16",
        "height": "16",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "fill-rule": "evenodd",
        "d": "M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208"
      }
    })])]), _vm._v(" " + _vm._s(_vm.truncateFilename(doc.original_file_name)) + " ")]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "iha-card-maincontainer"
  }, [_c('div', {
    staticClass: "heading-section d-flex align-items-center"
  }, [_c('div', {
    staticClass: "icon-wrapper d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "m5.6 19.92l1.524-1.219l.01-.008c.318-.255.479-.383.658-.474q.241-.123.508-.178C8.499 18 8.706 18 9.122 18h8.681c1.118 0 1.678 0 2.105-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.804V7.197c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C19.48 4 18.92 4 17.8 4H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 5.52 3 6.08 3 7.2v11.471c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.377c.35 0 .766-.334 1.599-1"
    }
  })])]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Conversation")])]), _c('div', {
    staticClass: "body-container d-flex flex-column"
  }, [_c('div', {
    staticClass: "messages"
  }, [_vm.messages.length ? _vm._l(_vm.messages, function (msg) {
    return _c('div', {
      key: msg.id,
      class: ['message-row', msg.role]
    }, [msg.role === 'admin' ? _c('div', {
      staticClass: "avatar"
    }, [_vm._v(" " + _vm._s(_vm.getInitial(msg.name)) + " ")]) : _vm._e(), _c('div', {
      staticClass: "message-bubble"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(msg.name))]), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(msg.time))])]), _c('p', {
      staticClass: "message-text"
    }, [_vm._v(" " + _vm._s(msg.text) + " ")]), msg.document && msg.document.length > 0 ? _c('div', {
      staticClass: "message-documents mt-2 d-flex flex-wrap gap-2"
    }, _vm._l(msg.document, function (doc) {
      return _c('div', {
        key: doc.id,
        staticClass: "file_list-item",
        staticStyle: {
          "cursor": "pointer",
          "padding": "4px 8px",
          "border-radius": "4px",
          "font-size": "12px",
          "background": "#eaeff5",
          "max-width": "180px",
          "overflow": "hidden",
          "white-space": "nowrap",
          "text-overflow": "ellipsis",
          "display": "inline-flex",
          "align-items": "center"
        },
        attrs: {
          "title": doc.original_file_name
        },
        on: {
          "click": function click($event) {
            return _vm.previewFile(doc);
          }
        }
      }, [_c('span', {
        staticClass: "icon",
        staticStyle: {
          "color": "#6c757d",
          "margin-right": "4px"
        }
      }, [_c('svg', {
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "14",
          "height": "14",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "fill-rule": "evenodd",
          "d": "M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208"
        }
      })])]), _vm._v(" " + _vm._s(_vm.truncateFilename(doc.original_file_name)) + " ")]);
    }), 0) : _vm._e()]), msg.role === 'user' ? _c('div', {
      staticClass: "avatar"
    }, [_vm._v(" " + _vm._s(_vm.getInitial(msg.name)) + " ")]) : _vm._e()]);
  }) : _c('div', {
    staticClass: "no-conversation flex-column"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "m5.6 19.92l1.524-1.219l.01-.008c.318-.255.479-.383.658-.474q.241-.123.508-.178C8.499 18 8.706 18 9.122 18h8.681c1.118 0 1.678 0 2.105-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.804V7.197c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C19.48 4 18.92 4 17.8 4H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 5.52 3 6.08 3 7.2v11.471c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.377c.35 0 .766-.334 1.599-1"
    }
  })])]), _vm._m(1)])], 2), _vm.isConversationDisabled ? _c('div', {
    staticClass: "conversation-closed-notice"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
    }
  })]), _c('span', [_vm._v("Conversation is "), _c('strong', [_vm._v(_vm._s(_vm.issue.status))]), _vm._v(". Replies are no longer accepted for this issue.")])]) : _c('div', {
    staticClass: "reply-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.reply,
      expression: "reply"
    }],
    attrs: {
      "placeholder": "Type your message ...."
    },
    domProps: {
      "value": _vm.reply
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.reply = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "reply-footer d-flex justify-content-between align-items-center flex-wrap"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "attachment",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.commentFile.click();
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "d": "M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208"
    }
  })]), _c('span'), _vm._v(" Add Attachment ")]), _c('input', {
    ref: "commentFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm.commentFile ? _c('span', {
    staticClass: "ms-2 text-truncate",
    staticStyle: {
      "max-width": "150px",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.commentFile.name) + " "), _c('i', {
    staticClass: "fas fa-times text-danger ms-1",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.commentFile = null;
      }
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "ms-2",
    staticStyle: {
      "font-size": "12px",
      "color": "#6c757d"
    }
  }, [_vm._v("Max file size: 5 MB")])]), _c('button', {
    staticClass: "send-btn univ-btn d-flex align-items-center justify-content-center gap-2 m-0",
    attrs: {
      "disabled": _vm.isSendingReply
    },
    on: {
      "click": _vm.sendReply
    }
  }, [_vm.isSendingReply ? _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isSendingReply ? 'Sending...' : 'Send Reply') + " ")])])])])])])]), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "iha-card-maincontainer"
  }, [_c('div', {
    staticClass: "heading-section d-flex align-items-center"
  }, [_c('div', {
    staticClass: "icon-wrapper d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7z"
    }
  })])]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Status History")])]), _c('div', {
    staticClass: "body-container d-flex flex-column"
  }, [_c('div', {
    staticClass: "status-history-container d-flex flex-column gap-3"
  }, _vm._l(_vm.statusHistories, function (history) {
    return _c('div', {
      key: history.id,
      staticClass: "status_history-item"
    }, [_c('div', {
      staticClass: "dot"
    }), _c('div', {
      staticClass: "history-content"
    }, [!history.old_status ? _c('div', {
      staticClass: "history-status"
    }, [_vm._v(" Issue created with status "), _c('span', {
      staticClass: "fw-semibold"
    }, [_vm._v(" " + _vm._s(_vm.getIssueStatusLabel(history.new_status)) + " ")])]) : _c('div', {
      staticClass: "history-status"
    }, [_vm._v(" Status changed from "), _c('span', {
      staticClass: "fw-semibold"
    }, [_vm._v(" " + _vm._s(_vm.getIssueStatusLabel(history.old_status)) + " ")]), _vm._v(" to "), _c('span', {
      staticClass: "fw-semibold"
    }, [_vm._v(" " + _vm._s(_vm.getIssueStatusLabel(history.new_status)) + " ")])]), _c('div', {
      staticClass: "d-flex gap-2 flex-wrap info-text align-items-center"
    }, [_c('div', {
      staticClass: "user-name"
    }, [_vm._v(" " + _vm._s(history.agent_name) + " ")]), _c('div', {
      staticClass: "dot-sm"
    }), _c('div', {
      staticClass: "status-time"
    }, [_vm._v(" " + _vm._s(_vm.formatDateTime(history.created_at)) + " ")])])])]);
  }), 0)])])])])]), _vm.showWithdrawIssueModal ? _c('WithdrawIssueModal', {
    attrs: {
      "row": _vm.issue
    },
    on: {
      "close": function close($event) {
        _vm.showWithdrawIssueModal = false;
      },
      "withdraw": _vm.handleWithdraw
    }
  }) : _vm._e(), _c('b-modal', {
    attrs: {
      "size": "xl",
      "centered": "",
      "hide-footer": "",
      "hide-header-close": "",
      "modal-class": "attachment-preview-modal",
      "content-class": "attachment-preview-content",
      "body-class": "attachment-preview-body"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "attachment-preview-header align-items-end justify-content-end w-100 d-flex mb-3"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closePreviewModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.previewModalVisible,
      callback: function callback($$v) {
        _vm.previewModalVisible = $$v;
      },
      expression: "previewModalVisible"
    }
  }, [_vm.previewFileItem ? _c('div', {
    staticClass: "attachment-preview-shell"
  }, [_vm.isImage(_vm.previewFileItem) ? _c('img', {
    staticClass: "attachment-preview-image",
    attrs: {
      "src": (_vm$previewFileItem = _vm.previewFileItem) !== null && _vm$previewFileItem !== void 0 && _vm$previewFileItem.full_file_url ? _vm.previewFileItem.full_file_url : _vm.previewFileItem.url,
      "alt": _vm.previewFileItem.original_file_name
    }
  }) : _vm.isPdf(_vm.previewFileItem) ? _c('iframe', {
    staticClass: "attachment-preview-pdf",
    attrs: {
      "src": (_vm$previewFileItem2 = _vm.previewFileItem) !== null && _vm$previewFileItem2 !== void 0 && _vm$previewFileItem2.full_file_url ? _vm.previewFileItem.full_file_url : _vm.previewFileItem.url,
      "frameborder": "0",
      "title": _vm.previewFileItem.original_file_name
    }
  }) : _vm._e()]) : _vm._e()])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "icon-wrap"
  }, [_c('i', {
    staticClass: "fas fa-ban"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-wrap d-flex flex-column gap-0 align-items-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" No messages yet ")]), _c('div', {
    staticClass: "sm-text"
  }, [_vm._v(" Our team will reply here once reviewed. ")])]);
}]

export { render, staticRenderFns }